module.exports = __webpack_public_path__ + "img/pause.db8018f2.svg";